// Kept out of DashboardPage so the router can validate `?tab=` without loading the page chunk.
export const DASH_TABS = ['today', 'overview', 'quantities', 'money', 'clients', 'table'] as const;
export type DashTab = (typeof DASH_TABS)[number];
